import { auth } from "../../variables/services";

export const checkAccountName = async (account) => {
    const queryParams = new URLSearchParams({account: account}).toString();
    return fetch(`${auth}/account_exists?${queryParams}`, {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json"
        },
    })
    .then(res => {
        if (!res.ok) { 
            return res.json().then(data => {
                throw new Error("Error: " + (data.message || "Unknown error"));
            });
        }
        return res.json();
    })
    .then(data=>{
        const acccount_exists = data.account_exists;
        return acccount_exists;
    })
    .catch(error => {
        console.error("Error checking account:", error);
    });
};
